import React from 'react';
import { Link } from 'react-router-dom';
import FacebookIcon from '@material-ui/icons/Facebook';
import InstagramIcon from '@material-ui/icons/Instagram';
import TwitterIcon from '@material-ui/icons/Twitter';
import './FooterTextil.scss';

const FooterTextil = (props) => {
    const { client } = props;
  const year = new Date().getFullYear();

  const scrollToTop = () => window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });

  return (
    <footer className="footer">
      <div className="footer-links">
        <div className="footer-column">
            <span>
                {!!client && client.description}
            </span> 
          <div className="social-icons">
            <a href="#"><FacebookIcon /></a>
            <a href="#"><InstagramIcon /></a>
            <a href="#"><TwitterIcon /></a>
          </div>
        </div>

        <div className="footer-column">
          <h3 className="footer-title">Servicio al Cliente</h3>
          <ul className="footer-list">
            <li><Link to="/preguntas-frecuentes">FAQs frecuentes</Link></li>
            <li><Link to="/preguntas-frecuentes">Atención personalizada</Link></li>
          </ul>
        </div>

        <div className="footer-column">
          <h3 className="footer-title">Contacto</h3>
          <ul className="footer-list">
            <li><Link to="/contacto">Nosotros</Link></li>
            <li><Link to="/contacto">Contacto</Link></li>
            <li><Link to="/contacto">Local</Link></li>
          </ul>
        </div>
      </div>

      <div className="jaypion col-lg-12">
        &copy;
        {' '}
        {year}
        {' '}
        Derechos reservados por&nbsp;
        <a href="https://info.jaypionba.com/" target="_blank" rel="noopener noreferrer">
        Jaypion
        </a>

        <div className="bottom col-lg-4">
        <button className="scrollTop" onClick={scrollToTop} type="button">
          Ir al inicio
          <i className="fa fa-arrow-up" style={{ paddingLeft: '5px' }} aria-hidden="true" />
        </button>
      </div>
      </div>
    </footer>
  );
};

export default FooterTextil;
